function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.4667 3.51367H1.53333C1.23878 3.51367 1 3.75245 1 4.047V11.9528C1 12.2474 1.23878 12.4861 1.53333 12.4861H14.4667C14.7612 12.4861 15 12.2474 15 11.9528V4.04701C15 3.75245 14.7612 3.51367 14.4667 3.51367ZM1.53333 2.51367C0.686497 2.51367 0 3.20017 0 4.047V11.9528C0 12.7996 0.686496 13.4861 1.53333 13.4861H14.4667C15.3135 13.4861 16 12.7996 16 11.9528V4.04701C16 3.20017 15.3135 2.51367 14.4667 2.51367H1.53333Z",
  fill: "#004152"
});

var _ref3 = React.createElement("path", {
  d: "M0.724406 5.49841H15.2182V6.98002H0.724406V5.49841Z",
  fill: "#004152"
});

var SvgCard = function SvgCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/card.47a9be3f.svg";
export { ForwardRef as ReactComponent };